"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var PromotionConverter_1 = require("../../promotion/conversions/PromotionConverter");

var ReleaseItemPromos_1 = require("../model/ReleaseItemPromos");

var ReleaseItemPromosConverter_1 = require("./ReleaseItemPromosConverter");

var ReleaseItemPromosConverterImpl =
/*#__PURE__*/
function (_ReleaseItemPromosCon) {
  _inherits(ReleaseItemPromosConverterImpl, _ReleaseItemPromosCon);

  function ReleaseItemPromosConverterImpl(promoConverter) {
    var _this;

    _classCallCheck(this, ReleaseItemPromosConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemPromosConverterImpl).call(this));
    _this.promoConverter = promoConverter;
    return _this;
  }

  _createClass(ReleaseItemPromosConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      return {
        promotions: conversions.asObjectArray(source, 'promotions', function (p) {
          return _this2.promoConverter.toDocument(p, conversions);
        })
      };
    }
  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this3 = this;

      return new ReleaseItemPromos_1.ReleaseItemPromos(conversions.asObjectList(source, 'promotions', function (p) {
        return _this3.promoConverter.toObject(p, conversions);
      }));
    }
  }]);

  return ReleaseItemPromosConverterImpl;
}(ReleaseItemPromosConverter_1.ReleaseItemPromosConverter);

ReleaseItemPromosConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [PromotionConverter_1.PromotionConverter])], ReleaseItemPromosConverterImpl);
exports.ReleaseItemPromosConverterImpl = ReleaseItemPromosConverterImpl;